import { useRef } from "react";
import { styled } from "@mui/material";
import { Loader } from "components";

const ContainerStyled = styled("div")({
  display: "flex",
  gap: "0.625rem",
  marginBottom: "0.625rem",
  "& input": {
    width: "50px",
    height: "50px",
    textAlign: "center",
    fontSize: "24px",
    border: "1px solid #ccc",
    borderRadius: "5px",
    "&:disabled": {
      backgroundColor: "#f5f5f5",
      color: "#a0a0a0",
      border: "1px solid #ddd",
      cursor: "not-allowed",
      opacity: 0.7,
    },
  },
});

const VerificationCode = ({ otp, onChange, isLoading, onSubmit }) => {
  const inputRefs = useRef([]);

  const handleOtpChange = (index, value) => {
    const newOtp = [...otp];
    if (!value.length) {
      return;
    }
    if (isNaN(value)) {
      return;
    }
    newOtp[index] = value;
    onChange(newOtp);
    if (index < otp.length - 1) {
      inputRefs.current[index + 1].focus();
    }
    if (newOtp.every((digit) => digit !== "")) {
      onSubmit?.(newOtp);
    }
  };

  const handleCaptureBackspace = (index, e) => {
    if (e.key === "Backspace") {
      if (index > 0) {
        const currValue = otp[index];
        if (!currValue) {
          inputRefs.current[index - 1].focus();
          return;
        }
        const newOtp = [...otp];
        newOtp[index] = "";
        onChange(newOtp);
      }
    }
  };

  return (
    <ContainerStyled>
      {otp.map((digit, index) => (
        <input
          key={index}
          type="text"
          maxLength="1"
          value={digit}
          onChange={(e) => handleOtpChange(index, e.target.value)}
          onKeyDown={(e) => handleCaptureBackspace(index, e)}
          ref={(el) => (inputRefs.current[index] = el)}
          disabled={isLoading}
        />
      ))}
      {isLoading && <Loader />}
    </ContainerStyled>
  );
};

export default VerificationCode;
